import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import configureStore from '@Redux/configureStore';
import history from './history';
import memberSiteTheme from './theme/memberSiteTheme';
import App from './App';
import LiffProvider from './Providers/LiffProvider';
import computeLiffEntryRedirect from './Scripts/Login/computeLiffEntryRedirect';

/**
 * LIFF 進入點正規化：在 Router／路由守衛（PrivateRoute）掛載前，把 LINE 帶入的深連結
 * 還原成真實路徑（/auth?t=xxx），避免未登入守衛搶先把 / 導去 /login 而遺失 ?t= / liff.state。
 * 只處理 liff.state 與根路徑 ?t=；code / state 的 OAuth 回調仍交給 liff.init 處理。
 * 這是 SPA 內部路由還原、非 LIFF API 呼叫，不違反「init 前不可呼叫 LIFF API」的規則。
 */
const target = computeLiffEntryRedirect(window.location.pathname, window.location.search);
if (target) history.replace(target);

// 建立全站共用的 Redux store（未帶入 initialState，非伺服器端渲染）
const store = configureStore();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <StyledEngineProvider injectFirst>
        <ThemeProvider theme={memberSiteTheme}>
            <Provider store={store}>
                <Router history={history}>
                    <LiffProvider>
                        <App />
                    </LiffProvider>
                </Router>
            </Provider>
        </ThemeProvider>
    </StyledEngineProvider>
);
